import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { Question } from '@/types/form'

interface LayoutBlockSettingsProps {
  question: Question
  onChange: (patch: Partial<Question['settings']>) => void
}

export function LayoutBlockSettings({ question, onChange }: LayoutBlockSettingsProps) {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-slate-200 p-3">
      <div>
        <h4 className="text-sm font-semibold text-slate-950">版面區塊設定</h4>
        <p className="mt-1 text-xs leading-5 text-slate-500">
          版面區塊不收集答案，但會出現在填答流程中，協助分段、提示與引導。
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-2">
          <Label>視覺語氣</Label>
          <Select
            value={question.settings.layoutTone ?? 'neutral'}
            onValueChange={(layoutTone) =>
              onChange({ layoutTone: layoutTone as Question['settings']['layoutTone'] })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="neutral">中性</SelectItem>
              <SelectItem value="accent">強調</SelectItem>
              <SelectItem value="success">成功</SelectItem>
              <SelectItem value="warning">提醒</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="flex flex-col gap-2">
          <Label>對齊</Label>
          <Select
            value={question.settings.layoutAlignment ?? 'left'}
            onValueChange={(layoutAlignment) =>
              onChange({
                layoutAlignment: layoutAlignment as Question['settings']['layoutAlignment'],
              })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="left">靠左</SelectItem>
              <SelectItem value="center">置中</SelectItem>
              <SelectItem value="right">靠右</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {(question.type === 'INTRO_BLOCK' || question.type === 'STATEMENT') && (
        <div className="flex flex-col gap-2">
          <Label>提示標籤</Label>
          <Input
            value={question.settings.calloutLabel ?? ''}
            placeholder="例如：填答說明"
            onChange={(event) => onChange({ calloutLabel: event.target.value })}
          />
        </div>
      )}

      {question.type === 'DIVIDER' && (
        <>
          <div className="flex flex-col gap-2">
            <Label>分隔線樣式</Label>
            <Select
              value={question.settings.dividerStyle ?? 'solid'}
              onValueChange={(dividerStyle) =>
                onChange({ dividerStyle: dividerStyle as Question['settings']['dividerStyle'] })
              }
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="solid">實線</SelectItem>
                <SelectItem value="dashed">虛線</SelectItem>
                <SelectItem value="dotted">點線</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex flex-col gap-2">
            <Label>分隔標籤</Label>
            <Input
              value={question.settings.dividerLabel ?? ''}
              placeholder="例如：下一段"
              onChange={(event) => onChange({ dividerLabel: event.target.value })}
            />
          </div>
        </>
      )}
    </div>
  )
}
